import axios from "axios";
import router from '../../router';

const config = {};

if (process.env.NODE_ENV) {
  let baseUrl = process.env.VUE_APP_FULFILLMENT_API_BASE_URL;
  if (baseUrl[baseUrl.length - 1] === '/') {
    baseUrl = baseUrl.substring(baseUrl.length - 1);
  }
  config.baseURL = baseUrl;
  config.headers = {
    'Content-Type': 'application/json'
  };
}

export const $axios = axios.create(config);

$axios.interceptors.response.use(
    function(response) {
      return response;
    },
    async function(error) {
      if (error.response.status === 403) {
        try {
          await $axios.post('/auth/refresh', {}, { withCredentials: true });
          error.config.withCredentials = true;
          await router.push({ path: '/login' });
          return new Promise(resolve => resolve(axios(error.config)));
        } catch (error) {
          await router.push({ path: '/login' });
        }
      } else {
        return Promise.reject(error);
      }
    }
);
